var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bio"
  }, [_vm._m(0), _vm._v(" "), _c('external-profile-links')], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "skew-11-neg"
  }, [_c('div', {
    staticClass: "text-section"
  }, [_c('div', {
    staticClass: "text-section-title"
  }, [_vm._v("Hi, I'm Graham")]), _vm._v(" "), _c('div', {
    staticClass: "text-section-content"
  }, [_c('div', {
    staticClass: "bio__bio"
  }, [_c('div', {
    staticClass: "bio__bio-image"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/me.png"),
      "alt": "A picture of me."
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bio__bio-text"
  }, [_vm._v("\n            \"I'm a Senior Software Engineer working as a Technical Lead at "), _c('a', {
    attrs: {
      "href": "https://www.linkedin.com/company/yahoo/",
      "target": "_blank",
      "rel": "noreferrer nofollow"
    }
  }, [_vm._v("Yahoo")]), _vm._v(". I'm also studying part-time for my "), _c('a', {
    attrs: {
      "href": "https://www.dcu.ie/courses/postgraduate/school-computing/msc-computing-major-options",
      "target": "_blank",
      "rel": "noreferrer nofollow"
    }
  }, [_vm._v("M.Sc. in Secure Software Engineering")]), _vm._v(" at "), _c('a', {
    attrs: {
      "href": "https://dcu.ie/",
      "target": "_blank",
      "rel": "noreferrer nofollow"
    }
  }, [_vm._v("Dublin City University")]), _vm._v(" which I started in 2022. Before starting at Yahoo, I completed my "), _c('a', {
    attrs: {
      "href": "https://www.dcu.ie/courses/undergraduate/computing/computer-applications.shtml",
      "target": "_blank",
      "rel": "noreferrer nofollow"
    }
  }, [_vm._v("B.Sc. in Computer Applications")]), _vm._v(" with a first class honours result in 2018."), _c('br'), _c('br'), _vm._v("\n            I am passionate about building high quality software solutions in agile teams.\n            I believe in life-long learning.\"\n          ")])])])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c0ee3fd","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Bio.vue
// module id = fzQW
// module chunks = 0